import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {ProgressBar} from "primereact/progressbar";
import {classNames} from "primereact/utils";
import {Divider} from "primereact/divider";
import {checkPermissions} from "../../../../../redux/permissions/permissionsUtils";
import {setIVRConfigurationDialogVisible, setIVRConfigurationErrorFields, setSelectedIVRConfigurationIndex} from "../../../../../redux/actions/actionsIVRConfiguration";
import {setEditType} from "../../../../../redux/actions/actions";
import {getIVRConfigurationById} from "../../../../../redux/api/apiIVRConfiguration";

const IVRConfigurationListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const loader = useAppSelector(state => state.IVRConfigurationReducer.detailsLoading);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const ivrConfigurationPermissions = checkPermissions(rolesVision, 'IVRConfig');
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const ivrConfigurationData = useAppSelector(state => state.IVRConfigurationReducer.ivrConfigurationData.configuration)

    useEffect(() => {
    }, []);

    const {
        update: hasIVRConfigurationUpdatePermission,
    } = ivrConfigurationPermissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const fields = [
        {label: "ID", value: ivrConfigurationData?.flowId},
        {label: "Стан", value: ivrConfigurationData?.isActive ? 'Активна' : 'Не активна'},
        {label: "Опис", value: ivrConfigurationData?.description || '- - -'},
    ];

    const openEditor = () => {
        const flowId = ivrConfigurationData?.flowId ?? props.selectedRowData;
        if (flowId != null && jwtToken?.jwtToken) {
            dispatch(getIVRConfigurationById(flowId, jwtToken.jwtToken));
        }
        dispatch(setSelectedIVRConfigurationIndex(flowId));
        dispatch(setIVRConfigurationDialogVisible(true));
        dispatch(setIVRConfigurationErrorFields(null));
        if (hasIVRConfigurationUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    return (
        <div className="">
            <div className="relative">
                {loader && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
                <div className={classNames('grid', {'opacity-50': loader})} style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                    {windowWidth > 1248 && <div className="grid col-12 md:col-12 mb-0 flex justify-content-between">
                        <div className="field col-12 md:col-6 flex align-items-center flex-wrap m-0">
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">ID: {ivrConfigurationData?.flowId}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">{ivrConfigurationData?.name}</p>
                            </div>
                        </div>
                        <div className="col-12 md:col-5 flex align-items-center m-0 p-0 justify-content-end text-right">
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                            </div>
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                <p className="w-full">{ivrConfigurationData?.isActive ? 'Активна' : 'Не активна'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                <button className="close-button block cursor-pointer mr-1" onClick={() => {
                                    openEditor();
                                }}><span className={classNames('', {
                                    'pi pi-pencil': hasIVRConfigurationUpdatePermission,
                                    'pi pi-eye': !hasIVRConfigurationUpdatePermission
                                })}></span></button>
                                <button className="close-button block cursor-pointer ml-0" onClick={() => props.setSelectedRowData(null)}><span className="pi pi-times"></span></button>
                            </div>
                        </div>
                    </div>}
                    {windowWidth <= 1248 && <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            <p className="w-full">{ivrConfigurationData?.name || '-'}</p>
                        </div>
                        {(<div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                    {windowWidth <= 1248 && <>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-4 md:col-6 flex align-items-start m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-8 md:col-6 flex align-items-start m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                    </>}
                    {windowWidth > 1248 &&
                        <React.Fragment>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex align-items-center m-0">
                                <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                    <p className="w-full">Опис</p>
                                </div>
                            </div>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex m-0 scroll-detail-items">
                                <div className="field col-12 md:col-4 flex m-0 p-0">
                                    {ivrConfigurationData?.description || '- - -'}
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

export default IVRConfigurationListDetails;

